export default {

  getRules() {
    return {
        'disclosure_federal_e_sign': { required: true,messages: {required: "You must agree to the electronic disclosure." } },
        'account_service_auth': { required: true,messages: {required: "You must agree to the electronic disclosure." } },
        //'disclosure_marketing': { required: true, messages: { required: "You must select an option for the Consent to Auto-dialed Marketing Calls and Text Messages." } },
        // 'funding_method': { required: true, messages: { required: "Please select a funding method." } },
    }
  }
}